<template>
  <el-dialog
    :title="unableSelectReasonMapping[unableSelectReason]"
    v-model="dialogVisible"
    class="order-test add-on-unable-select-dialog"
    append-to-body
  > 
    <p>
      {{ testName }} {{ disableReasonExplain }}
    </p>
    <template v-slot:footer>
      <div v-if="this.unableSelectReason === 'Might Expire Soon'">
        <button @click="close" class='cancel-btn'>
          {{ $t("OrderPage[\"Cancel\"]") }}
        </button>
        <button @click="addTestAnyway" class='add-test-anyway-btn'>
          {{ $t("OrderPage[\"Add Test Anyway\"]") }}
        </button>
      </div>
      <button v-else @click="close" class='close-btn'>
        {{ $t("OrderPage[\"Close\"]") }}
      </button>
    </template>
  </el-dialog>
</template>
<script>

import { mapState } from 'vuex';

export default {
  props: {
    isShowDialog: {
      type: Boolean,
      default: true,
    },
    unableSelectReason: {
      type: String,
      default: 'Already Selected'
    },
    testName: {
      type: String,
      default: ''
    },
    addOnRemainingStabilityDays: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      dialogVisible: false,
    };
  },


  watch: {
    isShowDialog(newVal) {
      this.dialogVisible = newVal;
    },
  },
  computed: {
    ...mapState("orderTest", ["addOnAccessionId"]),
    unableSelectReasonMapping() {
      return {
        "Already Ordered": this.$t("OrderPage[\"Already Ordered\"]"),
        "Expired": this.$t("OrderPage[\"Expired\"]"),
        "Requires New Kit": this.$t("OrderPage[\"Requires New Kit\"]"),
        "Might Expire Soon": this.$t("OrderPage[\"Might Expire Soon\"]")
      };
    },
    disableReasonExplain() {
      if(this.unableSelectReason === 'Already Ordered') {
        return this.$t("OrderPage[\"cannot be removed because it is already in the original order.\"]");
      }
      else if(this.unableSelectReason === 'Expired') {
        return this.$t("OrderPage[\"cannot be added as it requires completion within a specific time frame and it has passed.\"]");
      }
      else if(this.unableSelectReason === 'Requires New Kit') {
        return this.$t("OrderPage[\"cannot be added to the order because it requires additional tube kit(s). To order this for your patient, place a new order.\"]");
      }
      else if(this.unableSelectReason === 'Might Expire Soon') {
        return this.$t("OrderPage[\"requires the sample to be processed within ${this.addOnRemainingStabilityDays} days. The sample might be expired by the time we receive it. By clicking Add Test Anyway, you are acknowledging that you cannot do a redraw if the sample we received have expired.\"]", { addOnRemainingStabilityDays: this.addOnRemainingStabilityDays })
      }
      return ''
    }
  },

  methods: {
    close(action) {
      this.$emit("close"); 
    },
    addTestAnyway(action) {
      this.$emit("addTestAnyway"); 
      this.$emit("close"); 
    },
  }
};
</script>
<style scoped>
.close-btn {
  width: 140px;
  height: 42px;
  flex-shrink: 0;
  background-color: #20A8C3;
  color: #FFF;
  font-family: 'Roboto';
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px; /* 173.333% */
  letter-spacing: 0.429px;
  border-radius: 5px;
}

.cancel-btn {
  border-radius: 4px;
  background: #E6E6E6;
  color: #4A4A4A;
  font-family: Roboto;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px; /* 173.333% */
  letter-spacing: 0.429px;
  padding: 8px 65px;
  margin-right: 26px;
}

.add-test-anyway-btn {
  border-radius: 4px;
  border: 1px solid #20A8C3;
  color: #20A8C3;
  font-family: Roboto;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px; /* 106.667% */
  padding: 14px 20px;
}
</style>

